const ModalObj = {
    el: null,
    open: () => {},
    openPromise: () => {},
    buttons: null,
    closeCB: false
}

const modalMap = {}

export function Modals(context = document) {
    const els = context.querySelectorAll('.js-modal')
    Array.from(els).map(createModal)

    document.addEventListener('click', (evt) => {
        const controls = evt.target.getAttribute('aria-controls')
        if (controls && modalMap[controls]) {
            modalMap[controls].open(evt.target)
        }
    })
}

export function createModal(el, closeCB = false) {
    const Obj = { ...ModalObj }
    init.call(Obj, el, closeCB)
    return Obj
}

function init(el, closeCB = false) {
    if (!el) {
        return
    }

    this.el = el
    this.closeCB = closeCB
    this.name = this.el.id
    modalMap[this.name] = this

    this.open = open.bind(this)
    this.openPromise = openPromise.bind(this)
    this.buttons = []

    this.el.addEventListener('click', (evt) => {
        if (
            evt.target.classList.contains('js-modal-close') ||
            evt.offsetX < 0 ||
            evt.offsetX > evt.target.offsetWidth ||
            evt.offsetY < 0 ||
            evt.offsetY > evt.target.offsetHeight
        ) {
            close.call(this, evt)
        }
    })
}

function close(evt) {
    this.el.close()
    this.buttons.forEach((btn) => {
        btn.setAttribute('aria-expanded', false)
    })

    if (this.closeCB) {
        this.closeCB(evt)
    }
}

function open(button = false) {
    this.el.showModal()

    if (button) {
        button.setAttribute('aria-expanded', true)

        if (!this.buttons.includes(button)) {
            this.buttons.push(button)
        }
    }
}

function openPromise() {
    this.el.showModal()

    return new Promise((res) => {
        this.closeCB = res
    })
}
